import React from "react";
import { motion } from "framer-motion";
import { pageVariants } from "../animations/pageTransitions"; // Import animation config
import "./Capabilities.css";
import pt from "../../practices_images/physical-therapy.jpg"; // Ensure this path is correct
import CollapsibleSection from "./CollapsibleSection"; // adjust path if needed

const PhysicalTherapy = () => {
  return (
  <motion.div
    variants={pageVariants}
    initial="initial"
    animate="animate"
    exit="exit"
  >
    <div className="cap-container">
      <h1>Physical Therapy</h1>

      <div className="cap-section">
        <div className="text-content">
          {/* ✅ First 2 sections: normal (always visible) */}
          <h3>Supporting recovery through disciplined operations</h3>
          <p>
            Physical therapy practices play a critical role in helping patients regain function and mobility. Care is delivered over time, progress must be carefully documented, and reimbursement depends on consistent, compliant processes.          </p>
          <p>
            We partner with physical therapy clinics to help them operate efficiently while maintaining focus on patient outcomes.
          </p>

          <h3>The Operating Environment</h3>
          <p>
            Physical therapy clinics manage high visit volumes, complex scheduling demands, and strict documentation requirements. Compliance standards and payer rules require precision, while staffing and administrative pressures can strain day to day operations.          <p>
          </p>
            Without strong systems in place, these demands can limit both clinical effectiveness and financial performance.
          </p>

          {/* ✅ Everything after: collapsible */}
          <CollapsibleSection title="Our Role">
            <p>
              We help physical therapy practices strengthen the operational and financial processes that support consistent care delivery.
            </p>
            <p>
              Our work focuses on improving scheduling and workflow efficiency, reinforcing documentation and coding accuracy, supporting reliable billing and reimbursement processes, and improving financial visibility across the practice.            
            </p>
            <p>
              Our approach is practical and aligned with the realities of physical therapy care.
            </p>
          </CollapsibleSection>

          <CollapsibleSection title="Enabling Sustainable Performance">
            <p>
              Our goal is to help clinics operate with stability and predictability.
            </p>
            <p>
              By reducing administrative friction and strengthening financial foundations, we support improved cash flow, better use of staff time, and a smoother experience for patients throughout their course of care.
            </p>
            <p>
              This creates an environment where therapists can focus on rehabilitation while leadership maintains control over operations.
            </p>
          </CollapsibleSection>

          <CollapsibleSection title="Looking Ahead">
            <p>
              As demand for physical therapy services continues to grow, the need for disciplined operations becomes even more important.
            </p>
            <p>
              We work with practices to build the structure and clarity required to support long term success.
            </p>
            <p>
              Let’s begin a conversation about how your clinic can move forward with confidence and purpose.
            </p>
          </CollapsibleSection>
        </div>

        {/* Image Section */}
        <div className="image-container">
          <img src={pt} alt="PT" />
        </div>

      </div>
    </div>
  </motion.div>
  );
};

export default PhysicalTherapy;
